"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MethodNotImplementedError extends Error {
    constructor(message) {
        super(message);
        this.name = "Method Not Implemented";
    }
}
exports.MethodNotImplementedError = MethodNotImplementedError;
class OperationNotSupportedError extends Error {
    constructor(message) {
        super(message);
        this.name = "Operation Not Supported";
    }
}
exports.OperationNotSupportedError = OperationNotSupportedError;
class QueryNotSupportedError extends Error {
    constructor(message) {
        super(message);
        this.name = "Query Not Supported";
    }
}
exports.QueryNotSupportedError = QueryNotSupportedError;
class DeleteError extends Error {
    constructor(message) {
        super(message);
        this.name = "Delete Error";
    }
}
exports.DeleteError = DeleteError;
